import { Store } from 'src/store/index';

const getUsedClipArtsPrice = (store: Store) => store.addon.usedClipArts.clipArtsPrice;
export default getUsedClipArtsPrice;
